<!--Main-->
<template>
  <el-breadcrumb class="app-breadcrumb" separator-class="el-icon-d-arrow-right">
    <template v-for="(item,index)  in levelList">
      <el-breadcrumb-item
        v-if="index >0 && item.meta.parentTitle"
        :key="index"
      >{{item.meta.parentTitle}}</el-breadcrumb-item>
      <el-breadcrumb-item v-if="index >0 && item.meta.title" :key="item.path">
        <router-link :to="item.redirect||item.path">{{item.meta.title}}</router-link>
      </el-breadcrumb-item>
    </template>
  </el-breadcrumb>
</template>
<!--item.components.default.name-->
<script>
export default {
  data() {
    return {
      levelList: null,
    };
  },
  methods: {
    /**
     * 生成面包屑的方法
     */
    getBreadcrumb() {
      let matched = this.$route.matched.filter(
        (item) => item.components.default.name
      );
      const first = matched[0];
      if (first && first.components.default.name !== "Home") {
        matched = [{ path: "/", meta: { title: "首页" } }].concat(matched);
      }
      this.levelList = matched;
    },
  },
  mounted() {
    this.getBreadcrumb();
  },
  watch: {
    $route(to, from) {
      this.getBreadcrumb();
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 8px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>







// WEBPACK FOOTER //
// src/components/breadcrumb.vue